import { render, staticRenderFns } from "./AchievementDetail.vue?vue&type=template&id=320c803e&"
import script from "./AchievementDetail.vue?vue&type=script&lang=js&"
export * from "./AchievementDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports